import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';

import DropDownMenu from './../../dropdowns/DropDownMenu.vue';
import ButtonCommon from './../../buttons/ButtonCommon.vue';
import { MenuItem } from './../../dropdowns/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'ActionCard',
  props: {
    moreTooltip: { default: undefined },
    actions: null,
    title: { default: undefined },
    description: { default: undefined },
    isActive: { type: Boolean, default: false }
  },
  emits: ["dropdown-menu-select", "click"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'dropdown-menu-select', value: string | number | boolean | object): void;
  (e: 'click', event: Event): void;
}), expose: any, slots: any, attrs: any }) {

const actionCardHover = ref(false);
const actionCardActive = ref(false);





function actionCardClicked(event: Event) {
  actionCardActive.value = false;
  emit('click', event);
}

function onMouseLeave() {
  actionCardHover.value = false;
  actionCardActive.value = false;
}

return { __sfc: true,actionCardHover, actionCardActive, emit, actionCardClicked, onMouseLeave, DropDownMenu, ButtonCommon }
}

})